import { Suspense, lazy } from 'react';
import type { ScoreGame } from '@shared/types/game';

/**
 * The charting library is by far the heaviest thing the app loads, and the
 * round-by-round scorekeeping flow never touches it. Splitting it out keeps the
 * part you use at the table small — which also means less to precache for
 * offline use.
 */
const StandingsChart = lazy(() => import('@/components/StandingsChart'));

export default function LazyStandingsChart({ game }: { game: ScoreGame }) {
  return (
    <Suspense
      fallback={
        <div className="h-64 animate-pulse rounded-xl bg-base-900/60" aria-label="Grafiek laden" />
      }
    >
      <StandingsChart game={game} />
    </Suspense>
  );
}
